import { createBrowserRouter, Navigate } from 'react-router-dom'

import appRouter from './appRouters'
import Login from '@/pages/login'

export const menuRouterConfigList = [
  {
    path: '/',
    element: <Navigate to='/platform/dashboard' />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  ...appRouter,
]

const router = createBrowserRouter(menuRouterConfigList)

export default router
